module.exports = __webpack_public_path__ + "static/media/start-up.7f987052.svg";